import Screen from "src/shared/components/layout/screen/Screen"
import ProductividadCamaristas from "./sections/productividad-camaristas/ProductividadCamaristas"
import { useMemo, useState } from "react"
import DateFilter from "./components/date-filter/DateFilter"
import { useDate } from "src/shared/hooks/useDate"
import { ReportsOptions, ReportsSections, ReportsSubSections } from "./Reports.type"
import ArticulosVendidos from "./sections/articulos-vendidos/ArticulosVendidos"
import Huespedes from "./sections/huespedes/Huespedes"
import Incidencias from "./sections/incidencias/Incidencias"
import HistorialMantenimientos from "./sections/mantenimientos/Mantenimientos"
import Habitaciones from "./sections/habitaciones/Habitaciones"
import Inventarios from "./sections/inventarios/Inventarios"
import Propinas from "./sections/propinas/Propinas"
import FloatingMenu from "src/shared/components/data-display/floating-menu/FloatingMenu"
import { ButtonIcon } from "src/shared/components/forms/button-icon/ButtonIcon"
import HeaderLeft from "./components/header-left/HeaderLeft"
import VentasReservas from "./sections/ventas-y-reservas/VentasReservas"
import useEnergeticos from "./sections/energeticos/useEnergeticos"
import Gastos from "./sections/gastos/Gastos"
import MovimientosInventarios from "./sections/movimientos-inventarios/MovimientosInventarios"
import Matriculas from "./sections/matriculas/Matriculas"
import ReporteOrdenes from "./sections/ordenes/Ordenes"
import reportSelectedHandler from "./helpers/reportSelectedHandler"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import FormatUTCDateToApiDate from "../Cortes/EjmPDF/sections/helpers/FormatUTCDateToApiDate"

const Reports = () => {
    const { areSameDay, localDateToUTCString, getDayHoursRange } = useDate()
    const { formatCustomDate } = useFormatDate()
    const [dateFilter, setdateFilter] = useState<Date[] | null>(null)

    const { selectedSection, setSelectedSection } = reportSelectedHandler()

    const apiDateFilter = useMemo(() => {
        if (dateFilter?.[0] && dateFilter?.[1]) {
            return [
                FormatUTCDateToApiDate(localDateToUTCString(dateFilter[0]), true),
                FormatUTCDateToApiDate(localDateToUTCString(dateFilter[1]), true),
            ]
        }

        const { fecha_inicial, fecha_final } = getDayHoursRange(new Date())

        return [FormatUTCDateToApiDate(fecha_inicial, true), FormatUTCDateToApiDate(fecha_final, true)]
    }, [dateFilter])

    // Fechas a mostrar en el encabezado. Si aún no hay rango seleccionado usamos el
    // día de hoy como respaldo (igual que apiDateFilter) para que "Fecha:" nunca salga vacío.
    const headerDates = dateFilter?.length ? dateFilter : [new Date()]

    const { GetEnergeticos, AgregarEnergeticoButton } = useEnergeticos({ apiDateFilter })

    return (
        <Screen
            title={`${selectedSection.title} - ${
                selectedSection.value === ReportsSubSections.historialMatriculas
                    ? "Control vehicular"
                    : selectedSection.value
            }`}
            close
            headerLeft={
                <HeaderLeft>
                    {headerDates.length >= 2 && !areSameDay(headerDates[0], headerDates[1])
                        ? `${formatCustomDate(headerDates[0], "DD/MMM/YY")} al ${formatCustomDate(headerDates[1], "DD/MMM/YY")}`
                        : formatCustomDate(headerDates[0], "DD/MMM/YY")}
                </HeaderLeft>
            }
            headerRight={
                <>
                    {selectedSection.value === ReportsSubSections.historialEnergeticos && <AgregarEnergeticoButton />}
                    <DateFilter onChange={(v) => setdateFilter(v)} />
                    <FloatingMenu
                        value={selectedSection}
                        items={[
                            {
                                title: ReportsSections.habitacion,
                                subItems: [
                                    {
                                        title: ReportsOptions.habs.value,
                                        value: ReportsOptions.habs,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.huespedes.value,
                                        value: ReportsOptions.huespedes,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.limpSup.value,
                                        value: ReportsOptions.limpSup,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.ventasHabYReservas.value,
                                        value: ReportsOptions.ventasHabYReservas,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                ],
                            },
                            {
                                title: ReportsSections.finanzas,
                                subItems: [
                                    {
                                        title: ReportsOptions.artVendidos.value,
                                        value: ReportsOptions.artVendidos,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.gastos.value,
                                        value: ReportsOptions.gastos,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.propinas.value,
                                        value: ReportsOptions.propinas,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                ],
                            },
                            {
                                title: ReportsSections.operacion,
                                subItems: [
                                    {
                                        title: ReportsOptions.matriculas.value,
                                        value: ReportsOptions.matriculas,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.existenciaInventario.value,
                                        value: ReportsOptions.existenciaInventario,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.ordenes.value,
                                        value: ReportsOptions.ordenes,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    // {
                                    //     title: ReportsOptions.movimientosInventario.value,
                                    //     value: ReportsOptions.movimientosInventario,
                                    //     onSelect: (v) => setSelectedSection(v),
                                    // },
                                    {
                                        title: ReportsOptions.energeticos.value,
                                        value: ReportsOptions.energeticos,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.incidencias.value,
                                        value: ReportsOptions.incidencias,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                    {
                                        title: ReportsOptions.mantenimiento.value,
                                        value: ReportsOptions.mantenimiento,
                                        onSelect: (v) => setSelectedSection(v),
                                    },
                                ],
                            },
                        ]}
                    >
                        <ButtonIcon width="58px" iconName="PieChartFilled" theme="secondary" />
                    </FloatingMenu>
                </>
            }
        >
            {selectedSection.value === ReportsSubSections.historialLimpieza ? (
                <ProductividadCamaristas apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialArtVendidos ? (
                <ArticulosVendidos apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialHuespedes ? (
                <Huespedes apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialIncidencias ? (
                <Incidencias apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialMantenimiento ? (
                <HistorialMantenimientos apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialEnergeticos ? (
                <GetEnergeticos />
            ) : selectedSection.value === ReportsSubSections.historialHabitaciones ? (
                <Habitaciones apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialVentasYReserva ? (
                <VentasReservas apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialGastos ? (
                <Gastos apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialDeExistenciaInventarios ? (
                <Inventarios apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialDeMovimientosInventarios ? (
                <MovimientosInventarios apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialPropinas ? (
                <Propinas apiDateFilter={apiDateFilter} />
            ) : selectedSection.value === ReportsSubSections.historialMatriculas ? (
                <Matriculas apiDateFilter={apiDateFilter} canDownload canDelete />
            ) : selectedSection.value === ReportsSubSections.ordenes ? (
                <ReporteOrdenes apiDateFilter={apiDateFilter} />
            ) : null}
        </Screen>
    )
}

export default Reports
